export const environment = {
  production: false,
  apiUrl: 'https://bot-tel-api-dev-cwfgbqfch6h7f4d3.westeurope-01.azurewebsites.net'
};

